import { sidePanelPositionSelector } from "@client/widgets/SidePanel/selectors";
import { createSelector } from "reselect";

export const styleSelector = createSelector(
  [sidePanelPositionSelector],
  (sidePanelPosition): React.CSSProperties => ({
    flexDirection: sidePanelPosition === "wsc-sidepanel-right" ? "row-reverse" : "row",
    display: "flex",
    flex: 1,
    height: "100%",
    minWidth: 0 /* makes flex shrink correctly */,
    position: "relative"
  })
);
